import { RemoveClient } from "@domain/models/RemoveClient";

export const defaultRemoveClient: RemoveClient = {
  id: "",
  name: "",
  processes: "",
};
